import { render, staticRenderFns } from "./FlexiquoteModuleDetail.vue?vue&type=template&id=46ee5b0e&scoped=true"
import script from "./FlexiquoteModuleDetail.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee5b0e",
  null
  
)

export default component.exports